// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__15X7x","clinicsSelect":"TableHeading_clinicsSelect__180u7"};